var _line, _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _path3, _path4, _path5, _rect6, _rect7, _rect8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVehicleOutlineDepan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 360",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 330,
    x2: 570,
    y2: 330,
    stroke: "#c7ccd1",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 296,
    width: 30,
    height: 34,
    rx: 6,
    fill: "#2a2e33"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 296,
    width: 30,
    height: 34,
    rx: 6,
    fill: "#2a2e33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222 224 L246 150 Q250 140 264 140 L376 140 Q390 140 394 150 L418 224 Z",
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M238 220 L257 160 Q259 153 267 153 L373 153 Q381 153 383 160 L402 220 Z",
    fill: "#bfe0ec",
    stroke: "#204d63",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 190,
    width: 26,
    height: 16,
    rx: 5,
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 418,
    y: 190,
    width: 26,
    height: 16,
    rx: 5,
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 220,
    width: 284,
    height: 88,
    rx: 22,
    fill: "#2f6f8f",
    stroke: "#204d63",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M196 234 Q320 218 444 234",
    fill: "none",
    stroke: "#204d63",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190 238 L250 241 Q262 242 262 252 L262 258 Q262 265 254 265 L196 265 Q189 265 189 258 Z",
    fill: "#f6c945",
    stroke: "#a8791b",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M450 238 L390 241 Q378 242 378 252 L378 258 Q378 265 386 265 L444 265 Q451 265 451 258 Z",
    fill: "#f6c945",
    stroke: "#a8791b",
    strokeWidth: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 244,
    width: 84,
    height: 22,
    rx: 6,
    fill: "#1d4256"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 276,
    width: 260,
    height: 26,
    rx: 10,
    fill: "#1d4256"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 281,
    width: 60,
    height: 18,
    rx: 3,
    fill: "#e8eaed",
    stroke: "#8b9096",
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleOutlineDepan);
export default __webpack_public_path__ + "static/media/vehicle-outline-depan.878a05283bdd58d3412a5e834ae3a9c4.svg";
export { ForwardRef as ReactComponent };